import apiClient from "./api";
import { generarUUID } from "../utils/idempotencyUtils";
const SOLICITUD_API_BASE_URL = "/solicitudes";
class SolicitudesService {
    getSolicitudes() {
        return apiClient.get(SOLICITUD_API_BASE_URL);
    }

    getEstudiosPorSolicitud(idSolicitud) {
        return apiClient.get(`/solicitudesEstudios/solicitud/${idSolicitud}`);
    }

    agregarSolicitud(solicitud) {
        const payloadFinal = typeof solicitud === "object" ? { idempKey: generarUUID(), ...solicitud } : solicitud;
        return apiClient.post(SOLICITUD_API_BASE_URL, payloadFinal);
    }
    updateSolicitud(solicitud, solicitudId) {
        return apiClient.put(SOLICITUD_API_BASE_URL + "/" + solicitudId, solicitud);
    }

    updateEstatusSolicitud(idSolicitud, estatusResultados = "EN") {
        return apiClient.put(`${SOLICITUD_API_BASE_URL}/estatus/${idSolicitud}`, { estatusResultados, estatus: estatusResultados });
    }

    updateSolicitudRecibe(solicitud, solicitudId) {
        return apiClient.put(SOLICITUD_API_BASE_URL + "/recibe/" + solicitudId, solicitud);
    }

    deleteSolicitud(solicitud) {
        return apiClient.delete(SOLICITUD_API_BASE_URL, {
            headers: { "Content-Type": "application/json" },
            data: solicitud
        });
    }

    getSolicitudesResultados() {
        return apiClient.get(`${SOLICITUD_API_BASE_URL}/resultados`);
    }

    async buscarSolicitudesCN(busqueda) {
        try {
            const response = await apiClient.post(
                `${SOLICITUD_API_BASE_URL}/buscar/cn`,
                { busqueda },
            );
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    async getSolicitudIndividual(solicitudId) {
        try {
            const response = await apiClient.get(
                `${SOLICITUD_API_BASE_URL}/${solicitudId}`,
            );
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    uploadTicketWhatsApp(formData, idSolicitud) {
        return apiClient.post(`${SOLICITUD_API_BASE_URL}/ticket/upload/${idSolicitud}`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
    }

    enviarCorreoInforme(formData) {
        return apiClient.post(`${SOLICITUD_API_BASE_URL}/enviar-correo`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
    }

    getQrToken(idSolicitud) {
        return apiClient.get(`${SOLICITUD_API_BASE_URL}/qr/token/${idSolicitud}`);
    }

}
export default new SolicitudesService();
